import React from 'react';
import ReactDOM from 'react-dom';
import ua from 'ua-parser-js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NoResult from '../../components/general/NoResult';
import TimeAgo from 'react-timeago'
import General from '../../helpers/General.js';
import Confirm from '../../components/Confirm.js';
import Select from 'react-select';
import {pushState, Link} from 'react-router';

import GeneralHelper from '../../modules/General.js';
import SocketManager from '../../modules/SocketManager.js';
import axios from 'axios';
import {setVisitorKey,removeVisitor,chatSetGlobalKey,addMessage,setAssignee,setOpenChat,resetFilterOption,setFilterOption,removeFilterOption} from '../../actions/Chat.js';
import moment from 'moment';
import Gravatar from 'react-gravatar';
import Loading from '../../components/Loading.js';

import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import Template from "../settings/Template";
import Tooltip from 'rc-tooltip';
import ConversationListElement from './ConversationListElement';
import ConversationInfo from './ConversationInfo';
import Notification from '../../components/Notification';
import linkifyStr from "linkifyjs/string";

class ChatConversation extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'inputValue':'',
			'location': false,
			'loaded':false,
			'askClose':false,
			showTemplates:false,
            currentTemplate:false,
			isEditingTemplate:false,
		};

		this.type_timer = null;

		this.didDrawMap = false;

	}

	openChat = (uid) => {
		let user_id = this.currentUserView();

		this.setState({
			'loaded':false
		});
		this.props.setOpenChat(uid,user_id);
		this.props.router.push(GeneralHelper.Link('/chat/'+user_id+'/'+uid));
	}

	currentUserView = () => {
		let user_id = this.props.auth.user.id;
		if(this.props.router.params.user_id) {
			user_id = this.props.router.params.user_id;
		}

		return user_id;
	}


	componentWillReceiveProps(next) {
		if(!next.chat.visitors[this.props.router.params.uid] && this.props.router.params.uid) {
			this.props.router.push(GeneralHelper.Link('/chat/'+this.props.auth.user.id));
			return;
		}

		if(next.chat.currentChat != this.props.chat.currentChat) {
			this.load();
		}
	}

	componentDidMount() {
		if(this.props.router.params.uid && !this.props.chat.currentChat) {
			let user_id = this.currentUserView();

			this.setState({
				'loaded':false
			});
			this.props.setOpenChat(this.props.router.params.uid,user_id);
		}
	}

	componentWillMount() {
		if(!this.exists() && this.props.router.params.uid) {
			this.props.router.push(GeneralHelper.Link('/chat/'+this.props.auth.user.id));
			return;
		}
	}

	componentDidUpdate() {
		if(!this.state.loaded) {
			this.load();
		}

		this.scrollToBottom();

	}

	scrollToBottom() {
		if(this.props.router.params.uid && this.refs.messages) {
			this.refs.messages.scrollTop = this.refs.messages.scrollHeight;
		}
	}

	load = () => {
		if(!this.props.chat.visitors[this.props.router.params.uid] || this.props.chat.waitingForVisitorResponse ) {
			return;
		}

		this.newConversationOpened();

		this.didDrawMap = false;

		this.setState({
			loaded:true,
		});

		axios.post('/ajax/IpLocation',{'ip':this.props.chat.visitors[this.props.router.params.uid].ip}).then(res => {
			this.setState({
				location:res.data,
			});
			try {
                setTimeout(() => {
                    this.drawMap();
				},1000);
			} catch(err) {
				console.dir(err);
			}
		});
	}

	assignedTo = () => {
		let a2 = 'Nobody';

		if(this.props.general.users.length == 0 || !this.props.chat.visitors[this.props.router.params.uid]) {
			return 'Nobody';
		}

		for(let i in this.props.general.users) {
			if(this.props.general.users[i].id == this.props.chat.visitors[this.props.router.params.uid].assignee_id) {
				let name = 'Me';
				if(this.props.general.users[i].id != this.props.auth.user.id) {
					name = this.props.general.users[i].firstname;
				}
				a2 = name;
			}
		}

		return a2;
	}

	messages = () => {
		if(!this.exists()) {
			return [];
		}

		if(!this.props.chat.conversations[this.props.router.params.uid]) {
			return [];
		}

		let messages = [
			...this.props.chat.conversations[this.props.router.params.uid]
		];

		messages = messages.map(message => {
			return JSON.parse(message);
		});

		return messages;
	}

	info() {
		return this.props.chat.visitors[this.props.router.params.uid];
	}

	convertLinkToHTML(message) {
		return linkifyStr(message,{
			className:'crall-chat-link',
		});
	}

	message(message) {
		return (
			<div className="chat-content">
				<p dangerouslySetInnerHTML={General.createDangerousHtml(this.convertLinkToHTML(message.text))}></p>
				<span className="chat-time">{moment(General.toLocalTime(message.created_at)).fromNow()}</span>
				<span style={{fontSize:'11px'}}>Sent by {typeof message.email === 'undefined' ? 'chat':message.email == '1' ? 'email':'chat' }</span>
			</div>
		)
	}

	renderMessages = () => {
		let ret = [];
		this.messages().map((message,i)=> {
			ret.push(
				<div key={i} className={`${message.from == 0 ? '':'chat-left'}`}>
				    <div className="chat-avatar">
				    	<a className="avatar">
				    		{message.from == 0 ?
				    			<Gravatar email={this.info().email ? this.info().email : 'nobody'} size={100} rating="pg" default="identicon" className="img-responsive" />
				    		:
				    			<img src={message.image} className="img-responsive" />
				    		}

				    	</a>
				    </div>


					<div className="chat-body">
						{
							message.url != '' && message.url ?
								<Tooltip placement="top" overlay={<span>Sent from {message.url}</span>}>
                                    {this.message(message)}
								</Tooltip>
								:this.message(message)
						}


					</div>
			    </div>
			);
		});

		return ret;
	}

	setValue = (val) => {
		this.setState({'inputValue':val});
	}

	handleInput = (e) => {
		this.setValue(e.target.value);
	}

	operatorIsTyping = (status) => {
		SocketManager.operatorIsTyping(this.props.router.params.uid,this.props.auth.user.id,status);
	}

	componentWillUnmount() {
		if(this.type_timer !== null) {
            clearTimeout(this.type_timer);
            this.type_timer = null;
			this.operatorIsTyping(0);
		}
	}

	handleKeypress = (e) => {
		if(e.key == 'Meta') {
			return false;
		}

		if(parseInt(this.info().online) == 1) {
            if (this.type_timer === null) {
                this.operatorIsTyping(1);
            }
            clearTimeout(this.type_timer);

            this.type_timer = setTimeout(() => {
                this.type_timer = null;
                this.operatorIsTyping(0);
            }, 6000);
        }



		if(e.key == 'Enter') {
			e.preventDefault();

			if (!this.state.inputValue.replace(/\s/g, '').length) {
			   	return false;
			}

			let message = {
		        'text':this.state.inputValue,
		        'image':this.props.auth.user.image,
		        'from':this.props.auth.user.id,
				'uid':this.info().uid,
		        'created_at':moment().utc().format(),
		    };

            if(this.info().online == 0 && this.isEmail(this.info().email)) {
                message.email = 1;
            }

            if(this.info().online != 0) {
                clearTimeout(this.type_timer);
                this.type_timer = null;

                this.operatorIsTyping(0);
            }

            SocketManager.sendMessage(message);

            if(this.info().online == 0 && this.isEmail(this.info().email)) {
				axios.post('/conversations/'+this.info().uid+'/email',{message});
            }

            if(this.info().online == 0 && !this.isEmail(this.info().email)) {
            	Notification.error("Couldn't send message by e-mail. Unknown e-mail address.");
			}

        	if(this.info().assignee_id == 0) {
                this.assign(this.props.auth.user.id);
			}

			this.setValue('');

		}
	}

	isEmail(email) {
		if(!email) {
			return false;
		}

		if(typeof email !== 'string') {
			return false;
		}

		if(email === '') {
			return false;
		}

		return true;
	}

	renderIsTyping() {
		if(!this.exists()) {
			return null;
		}

		if(this.info().isTyping == 1) {
			return (
				<div>
				    <div className="chat-body">
					    <div className="chat-content">
					    	<div className="isTyping">
								<ul>
									<li className="p1"><i className="icon wb-medium-point" aria-hidden="true"></i></li>
									<li className="p2"><i className="icon wb-medium-point" aria-hidden="true"></i></li>
									<li className="p3"><i className="icon wb-medium-point" aria-hidden="true"></i></li>
								</ul>
								<div className="clearfix"></div>
							</div>
					    </div>
				    </div>
			    </div>
			);
		}
	}

	applyTemplate = (e) => {
		this.setState({
            showTemplates: false,
            inputValue: this.props.templates[e.value].message
        });

		this.refs.input_message.focus();

	}

    handleTemplateSubmit = (e) => {

	}

    getMessageTemplates = () => {
        let ret = [];

        for(let i in this.props.templates) {
            ret.push({
                clearableValue:false,
                label:this.props.templates[i].name,
                value:i,
            })
        }

        return ret;
	}

	renderConversation = () => {
		return (
			<div className="full-height">
			<div className="col-md-5 c" >
					<div className="col-sm-12 p-10 top">
						<div className="col-sm-6">
						<div className="dropdown">
							<button type="button" className="btn btn-default btn-sm dropdown-toggle" id="assignee" data-toggle="dropdown" aria-expanded="true">
							<strong>Assigned to:</strong> {this.assignedTo()}
							</button>
							<div className="dropdown-menu" aria-labelledby="assignee" role="menu">
							{this.props.general.users.map(user => {
								return <a key={user.id} onClick={(e) => {e.stopPropagation(); this.assign(user.id)} } className="dropdown-item" href="javascript:void(0)" role="menuitem">{user.firstname}</a>
							})}
							</div>
						</div>
						</div>
						<div className="col-sm-6 text-right">
							<button onClick={() => {this.setState({askClose:true})}} className="btn btn-sm btn-default"><i className="icon wb-close"></i>Close conversation</button>
						</div>
					</div>
					<div ref="messages" className="messages">
						{this.renderMessages()}
						{this.renderIsTyping()}
					</div>

					<form className="app-message-input">
						<div className="message-input">
							<textarea
								ref="input_message"
								className="form-control message"
								rows="1"
								placeholder="Write a message, <enter> to send"
								value={this.state.inputValue}
								onChange={this.handleInput}
								onKeyDown={this.handleKeypress}
								disabled={!this.props.chat.isOnline}
							></textarea>
							{this.state.showTemplates ?
								<div className="chat-templates">
									<div className="select-up template-arrow_box">
										<Select
											clearable={false}
											name="form-field-name"
											value={false}
											autofocus={true}
											options={this.getMessageTemplates()}
											onChange={this.applyTemplate}
										/>
										<br />
										<button onClick={e => {e.preventDefault(); e.stopPropagation(); this.setState({isEditingTemplate:true})}} className="btn btn-sm btn-dark"><i className="icon wb-plus"></i> Add template</button>
									</div>
								</div>:null}
							<div style={{position:'absolute','top':0,right:0}}>
								<button onClick={e => {e.stopPropagation(); this.setState({showTemplates:!this.state.showTemplates})}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-star" aria-hidden="true"></i></button>
							</div>
						</div>
					</form>

				</div>

				<div className="col-md-4 d" >
					<div id="customGmap" style={{height:'300px'}} className="height-300">
						<i className="icon wb-map" aria-hidden="true"></i>
					</div>

					{
						this.exists() ?
						<ConversationInfo city={this.state.location.city} pages={this.props.chat.pages[this.props.router.params.uid]} cart={this.props.chat.cart[this.props.router.params.uid]} country={this.state.location.country} visitor={this.props.chat.visitors[this.props.router.params.uid]} />
						:null
					}


				</div>

				<Portal closeOnEsc onClose={e => {this.setState({currentTemplate:false,isEditingTemplate:false})}} isOpened={this.state.isEditingTemplate}>
					<FullScreenOverlay>
						<Template handleSave={this.props.getTemplates} onClose={e => {this.setState({currentTemplate:false,isEditingTemplate:false})}} templateId={this.state.currentTemplate ? this.state.currentTemplate : false}  />
					</FullScreenOverlay>
				</Portal>


				<Confirm onAccept={(e) => { this.closeConversation(e) }} onClose={() => {this.setState({askClose:false})}} param={this.state.askClose} title="Are you sure?" body="Close this conversation?" />

			</div>
		)
	}

	closeConversation() {
		axios.post('/conversations/'+this.info().uid+'/close');

        SocketManager.closeConversation(this.info().uid);

        this.props.setVisitorKey(this.info().uid,'unreadMessages',0);
        this.props.setVisitorKey(this.info().uid,'started',0);
		this.props.setVisitorKey(this.info().uid,'assignee_id',0);


        if(this.info().online == 0)  {
            this.props.removeVisitor(this.info().uid);
		}

        this.props.router.push(GeneralHelper.Link('/chat/'+this.props.auth.user.id));
	}

	assign(user_id) {
		this.props.setAssignee(user_id,this.props.router.params.uid);
		SocketManager.setAssignee(user_id,this.props.router.params.uid);
	}

	exists() {
		if(this.props.chat.visitors[this.props.router.params.uid]) {
			return true;
		}

		return false;
	}

	drawMap() {
		if(this.didDrawMap == true) {
			return false;
		}

		if(!this.exists()) {
			return false;
		}

		let lat = this.state.location.lat;
		let lng = this.state.location.long;

		if(!lat || !lng) {
			return '';
		}

		if(!document.querySelector('#customGmap')) {
			return;
		}

		this.didDrawMap = true;

		let map = new GMaps({
			el: '#customGmap',
			lat: lat,
			lng: lng,
			zoom:7,
			zoomControl: true,
			zoomControlOpt: {
			  style: "SMALL",
			  position: "TOP_LEFT"
			},
			panControl: true,
			streetViewControl: false,
			mapTypeControl: false,
			overviewMapControl: false

		  });

		  map.drawOverlay({
			lat: lat,
			lng: lng,
			content: '<i class="wb-map" style="font-size:40px;color:' + "#62a8ea" + ';"></i>',
		  });



		  map.addStyle({
			styledMapName: "Styled Map",
			styles: [{featureType:"landscape",elementType:"all",stylers:[{color:"#ffffff"}]},{featureType:"poi",elementType:"all",stylers:[{color:"#ffffff"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#37474f"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#76838f"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#37474f"}]},{featureType:"road.arterial",elementType:"geometry.fill",stylers:[{color:"#e0e0e0"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{color:"#e4eaec"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#000000"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#76838f"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"poi.attraction",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"all",stylers:[{color:"#e4eaec"},{weight:.5}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ccd5db"}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{visibility:"off"},{color:"#000000"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"},{color:"#000000"}]},{featureType:"poi",elementType:"labels.text",stylers:[{visibility:"on"},{color:"#37474f"}]},{featureType:"road.local",elementType:"labels.text",stylers:[{color:"#37474f"}]},{featureType:"transit",elementType:"all",stylers:[{color:"#e4eaec"}]},{featureType:"transit.station",elementType:"labels.text.fill",stylers:[{color:"#76838f"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#526069"}]},{featureType:"administrative.neighborhood",elementType:"labels.text",stylers:[{color:"#76838f"}]},{featureType:"poi",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"road.highway",elementType:"labels.icon",stylers:[{visibility:"on"},{hue:"#ffffff"},{saturation:-100},{lightness:50}]},{featureType:"water",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"administrative",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#526069"}]}],
			mapTypeId: "map_style"
		  });

		  map.setStyle("map_style");

}

	newConversationOpened() {
		SocketManager.read(this.props.router.params.uid);
	}

	render() {
		return (
			<div className="conversation">
				<div className="col-md-3 l" >
					{
						Object.keys(this.props.chat.visitors).filter((uid,i) => {
							return this.props.chat.visitors[uid].assignee_id == this.props.router.params.user_id;
						}).length > 0 ?
						<ul className="list-group list-group-full">
						{
							Object.keys(this.props.chat.visitors).map((uid,i) => {
								if(this.props.chat.visitors[uid].assignee_id == this.props.router.params.user_id) {
									return <ConversationListElement key={i} openChat={this.openChat} visitor={this.props.chat.visitors[uid]} />
								}
							})
						}
					</ul>:<div className="no-conversations"><i className="icon wb-emoticon" aria-hidden="true"></i></div>
					}
				</div>

				{
					this.props.router.params.uid
					?
					this.renderConversation()
					:
					null
				}
			</div>
		);
	}
}


const mapStateToProps = (state) => {
	return {
		chat:state.chat,
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setVisitorKey,removeVisitor,chatSetGlobalKey,addMessage,setAssignee,setOpenChat,resetFilterOption,setFilterOption,removeFilterOption},dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(ChatConversation)



// WEBPACK FOOTER //
// ./containers/chat/ChatConversation.js